module.exports = "https://coursera_assets.s3.amazonaws.com/images/d266099ac753c0c93d7d291257fee686.png";